var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.379684 8.55458L6.79762 14.7994C6.9173 14.9159 7.05938 15.0083 7.21575 15.0713C7.37212 15.1343 7.53972 15.1667 7.70897 15.1667C8.05079 15.1667 8.37861 15.0346 8.62032 14.7994C8.74 14.683 8.83493 14.5447 8.8997 14.3926C8.96447 14.2404 8.99781 14.0774 8.99781 13.9127C8.99781 13.5801 8.86202 13.2611 8.62032 13.0259L3.10089 7.66781L8.62032 2.30973C8.74063 2.19362 8.83612 2.05548 8.90128 1.90329C8.96645 1.75109 9 1.58784 9 1.42296C9 1.25808 8.96645 1.09483 8.90128 0.942636C8.83612 0.790438 8.74063 0.652302 8.62032 0.536193C8.50099 0.419129 8.35902 0.326211 8.20261 0.262802C8.04619 0.199393 7.87842 0.166749 7.70897 0.166749C7.53952 0.166749 7.37175 0.199393 7.21533 0.262802C7.05891 0.326211 6.91695 0.419129 6.79762 0.536193L3.58865 3.65862L0.379684 6.78104C0.259376 6.89715 0.163882 7.03529 0.0987158 7.18749C0.0335493 7.33969 0 7.50293 0 7.66781C0 7.83269 0.0335493 7.99594 0.0987158 8.14814C0.163882 8.30034 0.259376 8.43848 0.379684 8.55458Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector(1).633bf99ffe79fc665930cb7d5568cdb6.svg";
export { ForwardRef as ReactComponent };